import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiArrowRight,FiCode,FiTrendingUp,FiUsers}=FiIcons;

const Hero=()=> {
  const scrollToSection=(href)=> {
    const element=document.querySelector(href);
    if (element) {
      element.scrollIntoView({behavior: 'smooth'});
    }
  };

  return (
    <section id="hero" className="min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-600/10 to-indigo-600/10"></div>
      <div className="absolute top-20 left-10 w-20 h-20 bg-blue-200/30 rounded-full blur-xl"></div>
      <div className="absolute bottom-20 right-10 w-32 h-32 bg-indigo-200/30 rounded-full blur-xl"></div>
      
      <div className="max-w-6xl mx-auto text-center relative z-10">
        <motion.div
          initial={{opacity: 0,y: 50}}
          animate={{opacity: 1,y: 0}}
          transition={{duration: 0.8}}
        >
          <h1 className="text-4xl md:text-6xl font-bold text-gray-800 mb-6">
            Tips för din karriär inom{' '}
            <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
              IT-branschen
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto">
            Få expertråd och praktiska tips för att lyckas som IT-konsult i roller som tex software engineer eller data engineer
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <motion.button
              onClick={()=> scrollToSection('#webinar')}
              className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-8 py-4 rounded-xl font-semibold flex items-center space-x-2 hover:shadow-xl transition-all duration-300"
              whileHover={{scale: 1.05}}
              whileTap={{scale: 0.95}}
            >
              <span>Se webinaret</span>
              <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
            </motion.button>
            <motion.a 
              style={{color: 'rgb(37,99,235)'}} 
              href="https://tidycal.com/1wekx5e" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="border-2 border-blue-600 text-blue-600 px-8 py-4 rounded-xl font-semibold hover:bg-blue-600 hover:text-white transition-all duration-300"
              whileHover={{scale: 1.05}}
              whileTap={{scale: 0.95}}
            >
              Boka möte
            </motion.a>
          </div>

          {/* Statistics */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            {[
              {icon: FiCode,number: '25+',text: 'År som IT-konsult'},
              {icon: FiUsers,number: '200+',text: 'Traineer utbildade'},
              {icon: FiTrendingUp,number: '200+',text: 'Poddavsnitt'}
            ].map((stat,index)=> (
              <motion.div
                key={index}
                className="bg-white/80 backdrop-blur-sm p-6 rounded-2xl shadow-lg"
                initial={{opacity: 0,y: 30}}
                animate={{opacity: 1,y: 0}}
                transition={{duration: 0.6,delay: index * 0.2}}
                whileHover={{scale: 1.05}}
              >
                <SafeIcon icon={stat.icon} className="w-8 h-8 text-blue-600 mx-auto mb-3" />
                <div className="text-3xl font-bold text-gray-800 mb-2">{stat.number}</div>
                <div className="text-gray-600">{stat.text}</div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;